@let mainActionLabel = mainAction.labelSelector | select:'';
@let mainActionEnabled = enabled && (mainAction.enabledSelector | select:false);

<div class="mx-split-button-combination" [class.mx-disabled]="!mainActionEnabled">
  <mx-filled-button [label]="mainActionLabel" [color]="color" [enabled]="mainActionEnabled" (click)="onClick(mainAction)"
                    class="mx-split-button-main mx-nested-button"/>

  <mat-divider vertical/>

  <mx-filled-button [matMenuTriggerFor]="rightSideMenu" [startIcon]="toggleIcon" startIconClasses="mat-icon-size-4.5" [color]="color"
                    [enabled]="mainActionEnabled" class="mx-split-button-menu-toggle mx-nested-button"/>
</div>

<mat-menu #rightSideMenu="matMenu" [overlapTrigger]="false">
  <mx-menu-item [label]="mainActionLabel" [enabled]="mainActionEnabled" (click)="onClick(mainAction)"/>

  @for (action of additionalActions; track $index) {
    <mx-menu-item [label]="action.labelSelector | select:''" [enabled]="enabled && (action.enabledSelector | select:false)" (click)="onClick(action)"/>
  }
</mat-menu>
